import { Styles, generateClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const userInfoClasses = generateClasses('UserInfo', ['root', 'loginBtn', 'avatar', 'userName'] as const);

const styles: Styles = ({ theme, theme: { spacing, palette } }) => {
  const {
    appHeader: {
      elementHoverBackgroundColor,
      userMenu: { userNameColor, avatarColor },
    },
  } = getAppFrameTheme(theme);

  return {
    [`&.${userInfoClasses.root}`]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      textTransform: 'none',
      gap: spacing(1),
      outlineOffset: 0,

      '&:hover': {
        background: elementHoverBackgroundColor,
      },
    },
    [`.${userInfoClasses.loginBtn}`]: {
      margin: spacing(0, 2, 0, 1),
      borderColor: palette.common.white,
      color: palette.common.white,
    },
    [`.${userInfoClasses.avatar}`]: {
      color: avatarColor,
    },

    [`.${userInfoClasses.userName}`]: {
      color: userNameColor,
    },
  };
};

export default styles;
